import * as lodash from 'lodash/fp';
import { defineModule, localActionContext, localGetterContext } from "direct-vuex"

import * as ProcessReference from "@/lib/Util/Types/Workflow/Doc/ProcessReference";
import * as REST from '@/lib/Util/REST'
import { RootState } from '@/store/Shared'

const state = {
    value: [] as ProcessReference.T[],
    message: REST.getEmpty(),
}

const mutations = {
    updateValue(state: State, model: ProcessReference.T[] | null) {
        const values = model ?? []
        state.value = values;
    },
    updateMsg(state: State, v: REST.RestMessage) {
        state.message = v
    },
}

const getters = {
}

const actions = {
    async load(context: any, filter: string) {
        /* eslint-disable @typescript-eslint/no-use-before-define */
        const { commit, state } = actionCtx(context)
        const rootState = context.rootState as RootState
        try {
            const loading_msg = {
                ...state.message,
                loading: true
            }
            commit.updateMsg(loading_msg)
            commit.updateValue([])
            const req = {
                token: rootState.authentication?.token ?? "NO TOKEN",
                url: "/lookup/processRef/preparation",
                payload: { user_feature: filter },
                transformer: ProcessReference.tryParseList
            };
            const result = await REST.GET(state.message, req);
            const msg = {
                ...lodash.cloneDeep(result.msg),
                text: "Successfully loaded processReference list",
                timeout: 5000
            }
            commit.updateValue(result.value)
            commit.updateMsg(msg)
        }
        catch (ex) {
            const msg = {
                ...lodash.cloneDeep(state.message),
                text: JSON.stringify(ex)
            }
            commit.updateMsg(msg)
        }
    },
}

export const internal = {
    namespaced: true as const,
    state,
    mutations,
    getters,
    actions
}

export type Mutations = typeof mutations
export type State = typeof state
export type Getters = typeof getters
export type Actions = typeof actions

export const module = defineModule(internal)
export type Module = typeof module
export default module

const actionCtx = (context: any) => localActionContext(context, module)
